import { createRouter, createWebHistory } from 'vue-router';

import Login from '@/views/pages/pages/authentication/auth-login.vue'
import Forgot_Password from '@/views/pages/pages/authentication/forgot-password.vue'
import Reset_Password from '@/views/pages/pages/authentication/reset-password.vue'
import Success from '@/views/pages/pages/authentication/auth-success.vue'
import Crm_Error from '@/views/pages/pages/error/crm-error.vue'
import Error_404 from '@/views/pages/pages/error/error-404.vue'
import Error_500 from '@/views/pages/pages/error/error-500.vue'
import Blank_Page from '@/views/pages/pages/blank-page.vue'
import Welcome_Page from '@/views/pages/pages/welcome-page.vue'
import Coming_Soon from '@/views/pages/pages/coming-soon.vue'
import Under_Maintenance from '@/views/pages/pages/under-maintenance.vue'
import CRM from '@/views/pages/crm/crm-index.vue'
import ReportsList from '@/views/pages/crm/reports/reports-list.vue'
import Crm_Settings from '@/views/pages/settings/crm-settings.vue'
import Crm_Profile from '@/views/pages/settings/general-settings/crm-profile.vue'
import Crm_Security from '@/views/pages/settings/general-settings/crm-security.vue'
import Crm_Notifications from '@/views/pages/settings/general-settings/crm-notifications.vue'
import Credential from '@/views/pages/settings/general-settings/crm-credentilas.vue'
import PlanTypes from '@/views/pages/settings/general-settings/plan-types.vue'
import Website_Settings from '@/views/pages/settings/data-import/website-settings.vue'
import Upload_file from '@/views/pages/settings/data-import/upload-file.vue'
// users
import Users from '@/views/pages/settings/users/users.vue'
import Users_list from '@/views/pages/settings/users/users-list.vue'
import Create_user from '@/views/pages/settings/users/create-user.vue'
// pipeline
import PipeLines from '@/views/pages/settings/pipelines/pipelines.vue'
import PipeLines_list from '@/views/pages/settings/pipelines/pipelines-list.vue'
import Create_PipeLine from '@/views/pages/settings/pipelines/create-pipeline.vue'

import Data_status from '@/views/pages/settings/data-import/import-data-status.vue'
import Get_quoting from '@/views/pages/quoting/get-quoting.vue'
import Quoting from '@/views/pages/quoting/quoting-index.vue'
import Lookup from '@/views/pages/lookup/lookup-index.vue'
import SearchByMpan from '@/views/pages/lookup/search-by-mpan.vue'

// company admin
import Companies from '@/views/pages/companies/companies-index.vue'
import CompaniesAdminList from '@/views/pages/companies/companies-list.vue'
import Create_company from '@/views/pages/companies/create-company.vue'

// pipeline
import Supplier from '@/views/pages/settings/supplier/supplier.vue'
import Supplier_list from '@/views/pages/settings/supplier/supplier-list.vue'
import Create_Supplier from '@/views/pages/settings/supplier/create-supplier.vue'

//dropdowns
import DropdownList from '@/views/pages/settings/drop-downs/dropdown-list.vue'
import Dropdown from '@/views/pages/settings/drop-downs/dropdown.vue'

// Api clicks
import ApiClicks from '@/views/pages/settings/api-clicks/api-clicks.vue'
import ApiClicks_list from '@/views/pages/settings/api-clicks/api-clicks-list.vue'

// Company data export
import CompanyExport from '@/views/pages/settings/company-export/company-export.vue'
import CompanyExport_list from '@/views/pages/settings/company-export/company-export-list.vue'

// import data
import Map_data from '@/views/pages/settings/data-import/map-data.vue'
import Assign_data from '@/views/pages/settings/data-import/assign-data.vue'
import Validate from '@/views/pages/settings/data-import/validate.vue'
import Appearance from '@/views/pages/settings/data-import/appearance-settings.vue'
import Create_mode from '@/views/pages/settings/data-import/create-mode.vue'
import Error_logs from '@/views/pages/settings/data-import/error-logs.vue'
import ReportEdit from '@/views/pages/crm/reports/report-edit.vue'
import ReportOverview from '@/views/pages/crm/reports/report-overview.vue'
import CompaniesList from '@/views/pages/crm/organisation/organisation-list.vue';
import CreateOrganisation from '@/views/pages/crm/organisation/create-organisation.vue';
import ReportChart from '@/views/pages/crm/reports/report-chart.vue'

import PersonsList from '@/views/pages/crm/person/person-list.vue';
import CreatePerson from '@/views/pages/crm/person/create-person.vue';

import Crm_User from '@/views/pages/user/crm-user.vue'
import Manage_Users from '@/views/pages/user/manage-users.vue'
import Roles_Permissions from '@/views/pages/user/roles-permissions.vue'
import Crm_Permission from '@/views/pages/user/crm-permission.vue'
import Delete_Request from '@/views/pages/user/delete-request.vue'
import Crm_Report from '@/views/pages/report/crm-report.vue'
import Lead_Report from '@/views/pages/report/lead-reports/lead-reports.vue'
import Deal_Report from '@/views/pages/report/deal-reports/deal-reports.vue'
import Contact_Report from '@/views/pages/report/contact-reports/contact-reports.vue'
import Company_Report from '@/views/pages/report/company-reports/company-reports.vue'
import Project_Report from '@/views/pages/report/project-reports/project-reports.vue'
import Task_Report from '@/views/pages/report/task-reports/task-reports.vue'
import CompaniesGrid from '@/views/pages/crm/organisation/companies-grid.vue';
import OrganisationDetails from '@/views/pages/crm/organisation/organisation-details/organisation-details.vue';

// meter-opportunities
import OppLeadsList from '@/views/pages/crm/meter-opportunities/meter-opportunities-list.vue'
import LeadsKanban from '@/views/pages/crm/meter-opportunities/meter-opportunities-kanban.vue'
import MeterOppEdit from '@/views/pages/crm/meter-opportunities/meter-opportunities-edit.vue'
import MeterOppCreate from '@/views/pages/crm/meter-opportunities/create-meter-opportunity.vue'
import QuotedPrice from '@/views/pages/crm/meter-opportunities/quoted-price-list.vue'

import LeadsList from '@/views/pages/crm/leads/leads-list.vue'
import LeadsListAssigned from '@/views/pages/crm/leads/leads-list-assigned.vue'
import Activities from '@/views/pages/crm/activities/activities-list.vue'
import Dashboard from '@/views/pages/dashboard/dashboard-index.vue'
import DealsDashboard from '@/views/pages/dashboard/deals-dashboard/deals-dashboard.vue'
import Contracts_List from '@/views/pages/crm/contracts/contracts-list.vue'

// contracts
import Create_contract from '@/views/pages/crm/contracts/create-contract.vue'
import Edit_contract from '@/views/pages/crm/contracts/edit-contract.vue'

// Activity
import Create_activity from '@/views/pages/crm/activities/create-activity.vue'
import Edit_activity from '@/views/pages/crm/activities/edit-activity.vue'

// territory
import Territory from '@/views/pages/settings/territory/territory.vue'
import Territory_list from '@/views/pages/settings/territory/territory-list.vue'
import Create_territory from '@/views/pages/settings/territory/create-territory.vue'
import component from 'vue3-tags-input';

// Support case
import CreateSupportCase from '@/views/pages/crm/support/create-support-case.vue'
import EditSupportCase from '@/views/pages/crm/support/edit-support-case.vue'
import SupportCaseList from '@/views/pages/crm/support/support-case-list.vue'
import AdminSupportCaseList from '@/views/pages/crm/support/admin-support-list.vue'

import Quotes from '@/views/pages/crm/meter-opportunities/add-quotes.vue'

import store from "@/store"; // Import Vuex store (or Pinia if used)
import PozitiveUplift from '@/views/pages/settings/general-settings/pozitive-uplift.vue';

const routes = [
  {
    path: '/',
    name: 'login',
    component: Login
  },
  {
    path: '/forgot-password',
    name: 'forgot-password',
    component: Forgot_Password
  },
  {
    path: '/reset-password',
    name: 'reset-password',
    component: Reset_Password
  },
  {
    path: '/success',
    name: 'success',
    component: Success
  },
  {
    path: '/blank-page',
    name: 'blank-page',
    component: Blank_Page
  },
  {
    path: '/welcome-page',
    name: 'welcome-page',
    component: Welcome_Page
  },
  {
    path: '/coming-soon',
    name: 'coming-soon',
    component: Coming_Soon
  },
  {
    path: '/under-maintenance',
    name: 'under-maintenance',
    component: Under_Maintenance
  },
  {
    path: '/dashboard',
    component: Dashboard,
    children: [
      { path: '', redirect: '/dashboard/deals-dashboard' },
      { path: 'deals-dashboard', component: DealsDashboard },
    ],
    meta: { requiresAuth: true, permissions: ['Dashboard'] }
  },
  {
    path: '/quoting',
    component: Quoting,
    children: [
      { path: '', redirect: '/quoting/get-quoting' },
      { path: 'get-quoting', component: Get_quoting },
    ],
    meta: { requiresAuth: true, permissions: ['Quoting'] }
  },
  {
    path: '/lookup',
    component: Lookup,
    children: [
      { path: '', redirect: '/lookup/search-by-mpan' },
      { path: 'search-by-mpan', component: SearchByMpan },
    ],
    meta: { requiresAuth: true, permissions: ['ELECTRALINK'] }
  },
  {
    path: '/companies',
    component: Companies,
    children: [
      { path: '', redirect: '/companies/companies-list' },
      { path: 'companies-list', component: CompaniesAdminList },
      { path: 'create-company', component: Create_company } 
    ],
    meta: { requiresAuth: true, permissions: ['Company'] }
  },
  {
    path: '/report',
    component: Crm_Report,
    children: [
      { path: '', redirect: '/report/lead-reports' },
      { path: "lead-reports", component: Lead_Report },
      { path: "deal-reports", component: Deal_Report },
      { path: "contact-reports", component: Contact_Report },
      { path: "company-reports", component: Company_Report },
      { path: "project-reports", component: Project_Report },
      { path: "task-reports", component: Task_Report },
    ]
  },
  {
    path: '/error',
    component: Crm_Error,
    children: [
      { path: '', redirect: '/error/error-404' },
      { path: "error-404", component: Error_404 },
      { path: "error-500", component: Error_500 },
    ]
  },
  {
    path: '/user',
    component: Crm_User,
    children: [
      { path: '', redirect: '/user/manage-users' },
      { path: "manage-users", component: Manage_Users },
      { path: "roles-permissions", component: Roles_Permissions },
      { path: "permission", component: Crm_Permission },
      { path: "delete-request", component: Delete_Request },
    ],
    meta: { requiresAuth: true, permissions: ['Users'] }
  },
  {
    path: '/settings',
    component: Crm_Settings,
    children: [
      { path: '', redirect: '/settings/profile' },
      { path: "profile", component: Crm_Profile },
      { path: "security", component: Crm_Security, meta: { requiresAuth: true, permissions: ['General Settings'] } },
      { path: "company", component: Crm_Notifications, meta: { requiresAuth: true, permissions: ['General Settings', 'company_admin'] } },
      { path: "plan-types", component: PlanTypes, meta: { requiresAuth: true, permissions: ['General Settings'] } },
      { path: "credentials", component: Credential, meta: { requiresAuth: true, permissions: ['General Settings', 'company_admin'] } },
      // { path: "pozitive-uplifts", component: PozitiveUplift, meta: { requiresAuth: true, permissions: ['General Settings', 'company_admin'] } },
    ],
    // meta: { requiresAuth: true, permissions: ['General Settings'] }
  },
  {
    path: '/data-import',
    component: Website_Settings,
    children: [
      { path: '', redirect: '/data-import/import-data-status' },
      { path: "upload-file", component: Upload_file },
      { path: "import-data-status", component: Data_status },
      { path: "map-data", component: Map_data },
      { path: "assign-data", component: Assign_data },
      { path: "validate", component: Validate },
      { path: "appearance", component: Appearance },
      { path: "create-mode", component: Create_mode },
      { path: "error-logs", component: Error_logs },
    ],
    meta: { requiresAuth: true, permissions: ['Data Import'] }
  },
  {
    path: '/users',
    component: Users,
    children: [
      { path: '', redirect: '/users/users/users-list' },
      { path: "users-list", component: Users_list },
      { path: "create-user", component: Create_user },
    ],
    meta: { requiresAuth: true, permissions: ['Users'] }
  },
  {
    path: '/pipelines',
    component: PipeLines,
    children: [
      { path: '', redirect: '/pipelines/pipelines/pipelines-list' },
      { path: "pipelines-list", component: PipeLines_list },
      { path: "create-pipeline", component: Create_PipeLine },
    ],
    meta: { requiresAuth: true, permissions: ['Pipleline'] }
  },
  {
    path: '/supplier',
    component: Supplier,
    children: [
      { path: '', redirect: '/supplier/supplier/supplier-list' },
      { path: "supplier-list", component: Supplier_list },
      { path: "create-supplier", component: Create_Supplier },
    ],
    meta: { requiresAuth: true, permissions: ['Suppliers'] }
  },
  {
    path: '/territory',
    component: Territory,
    children: [
      { path: '', redirect: '/territory/territory-list' },
      { path: "territory-list", component: Territory_list },
      { path: "create-territory", component: Create_territory },
    ],
    meta: { requiresAuth: true, permissions: ['Territories'] }
  },
  {
    path: '/drop-downs',
    component: Dropdown,
    children: [
      { path: '', redirect: '/drop-downs/dropdown-list' },
      { path: "dropdown-list", component: DropdownList },
    ],
    meta: { requiresAuth: true, permissions: ['Dropdowns'] }
  },
  {
    path: '/api-clicks',
    component: ApiClicks,
    children: [
      { path: '', redirect: '/api-clicks/api-clicks-list' },
      { path: "api-clicks-list", component: ApiClicks_list },
    ],
    meta: { requiresAuth: true, permissions: ['API Clicks'] }
  },
  {
    path: '/company-export',
    component: CompanyExport,
    children: [
      { path: '', component: CompanyExport_list },
    ],
    meta: { requiresAuth: true, permissions: ['Company Data Export'] }
  },
  {
    path: '/crm',
    component: CRM,
    children: [
      // Reports
      { path: '', redirect: '/crm/reports-list', meta: { requiresAuth: true, permissions: ['Reports'] } },
      { path: 'reports-list', component: ReportsList, meta: { requiresAuth: true, permissions: ['Reports'] } },
      { path: 'report-edit', component: ReportEdit, meta: { requiresAuth: true, permissions: ['Reports'] } },
      { path: 'overview/report', component: ReportOverview, meta: { requiresAuth: true, permissions: ['Reports'] } },
      { path: 'report-chart', component: ReportChart, meta: { requiresAuth: true, permissions: ['Reports'] } },

      // organisation
      { path: 'organisation-list', component: CompaniesList, meta: { requiresAuth: true, permissions: ['Organisations'] } },
      { path: 'create-organisation', component: CreateOrganisation, meta: { requiresAuth: true, permissions: ['Organisations'] } },
      { path: 'organisation/merging', component: () => import('@/views/pages/crm/organisation/merging.vue'), meta: { requiresAuth: true, permissions: ['Organisations'] } },
      { path: 'companies-grid', component: CompaniesGrid, meta: { requiresAuth: true, permissions: ['Organisations'] } },
      { path: 'organisation-details', component: OrganisationDetails, meta: { requiresAuth: true, permissions: ['Organisations'] } },
      { path: 'move', component: () => import('@/components/move.vue'), meta: { requiresAuth: true, permissions: ['Organisations'] } },

      // person
      { path: 'person-list', component: PersonsList },
      { path: 'create-person', component: CreatePerson },

      // meter opportuities
      { path: 'meter-opportunities-list', component: OppLeadsList, meta: { requiresAuth: true, permissions: ['Meter Opportunities'] } },
      { path: 'meter-opportunities-kanban', component: LeadsKanban, meta: { requiresAuth: true, permissions: ['Meter Opportunities'] } },
      { path: 'meter-opportunities-edit/:id', component: MeterOppEdit, meta: { requiresAuth: true, permissions: ['Meter Opportunities'] } },
      { path: 'create-meter-opportunity', component: MeterOppCreate, meta: { requiresAuth: true, permissions: ['Meter Opportunities'] } },
      { path: 'quoted-price-list', component: QuotedPrice, meta: { requiresAuth: true, permissions: ['Meter Opportunities'] } },

      // activity
      { path: 'activities-list', component: Activities, meta: { requiresAuth: true, permissions: ['Activities'] } },
      { path: 'create-activity', component: Create_activity, meta: { requiresAuth: true, permissions: ['Activities'] } },
      { path: 'edit-activity', component: Edit_activity, meta: { requiresAuth: true, permissions: ['Activities'] } },

      // Leads

      { path: 'leads-list', component: LeadsList, meta: { requiresAuth: true, permissions: ['Leads'] } },
      { path: 'manual-leads-list', component: LeadsList, meta: { requiresAuth: true, permissions: ['Manual Leads'], manualLeads: true } },

      // { path: 'leads-list', 
      //   // component: LeadsList,
      //   children: [
      //     { path: '', redirect: '/crm/leads-list/unassigned' },
      //     { path: "unassigned", component: LeadsList },
      //     { path: "assigned", component: LeadsListAssigned }
      //   ],
      //   meta: { requiresAuth: true, permissions: ['Leads'] } },

      // contracts
      { path: 'create-contract', component: Create_contract, meta: { requiresAuth: true, permissions: ['Contracts'] } },
      { path: 'contracts-list', component: Contracts_List, meta: { requiresAuth: true, permissions: ['Contracts'] } },
      { path: 'edit-contract/:id', component: Edit_contract, meta: { requiresAuth: true, permissions: ['Contracts'] } },
      // { path: 'edit-contract', component: Edit_contract, meta: { requiresAuth: true, permissions: ['Contracts'] }},

      // Supports Case
      { path: 'create-support-case', component: CreateSupportCase, meta: { requiresAuth: true, permissions: ['Support Cases'] }  },
      { path: 'support-case-list', component: SupportCaseList, meta: { requiresAuth: true, permissions: ['Support Cases'] }  },
      { path: 'edit-support-case', component: EditSupportCase, meta: { requiresAuth: true, permissions: ['Support Cases'] } },
      // { path: 'support-case', component: EditSupportCase},

      // Supports Admin
      { path: 'support-list', component: AdminSupportCaseList, meta: { requiresAuth: true, permissions: ['Company'] } },
      { path: 'support-case', component: EditSupportCase, meta: { requiresAuth: true, permissions: ['Company'] }},
      { path: 'pozitive-uplift', component: PozitiveUplift, meta: { requiresAuth: true, permissions: ['Company'] }},

      // Quotes 
      { path: 'quotes', component: Quotes },
    ]
  },
  {
    path: "/:pathMatch(.*)*",
    component: Blank_Page,
    meta: { title: "Page Not Found" },
  },
];

export const router = createRouter({
  history: createWebHistory('/'),
  linkActiveClass: 'active',
  routes,
});

router.beforeEach(async (to, from, next) => {

  const data = store.getters['changelayout/getHeaderFrom'];
  if(data === 'meterOpp'){
    store.dispatch("changelayout/toggleHeader", "");
  }

  // const serverVersion  = await fetch('/version.json').then(res => res.json());
  // const currentVersion = localStorage.getItem('version');

  // // if(!currentVersion){
  // //   localStorage.setItem('version', serverVersion);
  // //   window.location.reload()
  // // }

  // if (serverVersion.version !== currentVersion) {
  //   localStorage.setItem('version', serverVersion.version);
  //   localStorage.setItem('forceReload', Date.now()); // triggers the storage event
  //   window.location.reload();
  // }
  
  // window.addEventListener('storage', (event) => {
  //   if (event.key === 'forceReload') {
  //     window.location.reload();
  //   }
  // });



  // Scroll to the top of the page on every route change
  window.scrollTo({ top: 0, behavior: 'smooth' });

  // Get authentication token and user data from localStorage
  const token = localStorage.getItem('authToken');
  const user = JSON.parse(localStorage.getItem('user')) || {}; // Ensure it defaults to an object
  const permissions = user.permissions || []; // Default to an empty array if permissions are undefined

  // Check authentication for protected routes
  if (to.meta.requiresAuth && !token) {
    return next('/'); // Redirect to login if not authenticated
  }

  // Check if the route requires specific permissions
  if (to.meta.permissions) {

    if (to.meta.permissions.includes('Company') && user && user?.roles?.[0] === 'super_admin') {
      return next()
    } 

    const hasPermission = to.meta.permissions.some(permission =>
      permissions.includes(permission)
    );

    if(to.path === '/settings/company' || to.path === '/settings/credentials'){
      if (hasPermission && user && user?.roles?.[0] === 'company_admin') {
        store.commit("SET_ACCESS_DENIED", false);
      } else {
        store.commit("SET_ACCESS_DENIED", true); // Update state
      }
    } else {
      if (!hasPermission) {
        store.commit("SET_ACCESS_DENIED", true); // Update state
      } else {
        store.commit("SET_ACCESS_DENIED", false);
      }
    }
    next();
  } else {
    store.commit("SET_ACCESS_DENIED", false);
    next();
  }

});


export default router;